var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"func-16"}},[_c('FuncionalidadeHeader',{attrs:{"titulo":_vm.tituloNavegacao}}),_c('SolicitacaoHistorico',{attrs:{"funcionalidade":_vm.funcionalidade,"rota-detalhe":_vm.rotaDetalhe}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }